module.exports = __webpack_public_path__ + "media/images/yogaplace1-25924aa19e782e370012f2e21487f204.png";